angular.module('study.dashboard')
    .component('dashboardMain', {
        templateUrl: 'modules/dashboard/main.html',
        controller: 'DashboardController',
    });
